import { Swiper } from './swiper-dK1UiadY.js';
import { A as A11y } from './a11y-DLppOU3x.js';
import './utils-Djv5ZeLF.js';

class QuickLinks extends HTMLElement {
  #swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this.#swiper, {
      modules: [A11y],
      slidesPerView: "auto",
      spaceBetween: 8,
    });
  }
}

customElements.define('quick-links', QuickLinks);
